// TODO: repair typing
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck

import React, { useEffect, useState } from 'react';
import { Skeleton, Modal } from 'antd';
import { ProductCode } from 'types';
import { useDispatch, useSelector } from 'react-redux';
import history from '../../app-router/history';
import ProductCodeTable from '../../components/templates/product-code-table';
import ButtonPrimary from '../../components/molecules/button-primary';
import Layout from '../../components/templates/layout';
import { useIntl } from '../../common/config/i18n';
import { isRequestError } from 'common/utils/error';
import ModalContentConfirm from '../../components/organisms/modal-content-confirm';
import MessageModal from '../../components/organisms/message-modal';
import {
  productCodesActions,
  productCodesSelectors,
  productCodeActions,
  UserInfoSelectors,
  productCodeSelectors,
  ClearStateSliceActions,
} from '../../common/config/store';
import { StyledMainTitle, StyledListUtil } from '../../common/styling/mixins';

const { StyledListWrapper, StyledListTitleWrapper, StyledListBoldWrapper, StyledListButtonWrapper } = StyledListUtil;

const ProductCodes: React.FC = () => {
  const dispatch = useDispatch();
  const { t } = useIntl();
  const [modalVisible, setModalVisible] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [productCode, setProductCode] = useState({ id: 0, Name: '' });
  const status = useSelector(productCodesSelectors.statusSelector);
  const error = useSelector(productCodeSelectors.errorSelector);
  const errorType = useSelector(productCodeSelectors.errorTypeSelector);

  const canWriteProductCodes = useSelector(UserInfoSelectors.hasWriteAccess('Typologies'));
  useEffect(() => {
    dispatch(productCodesActions.fetchProductCodes());
    dispatch(ClearStateSliceActions.clearStateSlice({ sliceReducer: 'ProductCode' }));
  }, [dispatch]);

  useEffect(() => {
    if (errorType && errorType === 'delete') setShowDeleteModal(true);
  }, [errorType]);

  const onDeleteHandler = (pc: ProductCode): void => {
    setProductCode({ id: pc?.id, Name: pc?.name });
    setModalVisible(true);
  };

  const onModalConfirm = (shouldRemove: boolean) => {
    if (shouldRemove) {
      dispatch(productCodeActions.deleteProductCode(productCode.id.toString()));
    }
    setModalVisible(false);
  };

  const onClickCreateHandler = (): void => {
    return history.push('/product-code');
  };

  return (
    <div>
      <MessageModal
        open={showDeleteModal}
        onClose={() => {
          setShowDeleteModal(false);
          dispatch(ClearStateSliceActions.clearStateSlice({ sliceReducer: 'ProductCode' }));
        }}
        errorMessage={error && isRequestError(error) ? undefined : error}
      />

      <Modal
        title={t('Modal', 'PRODUCT_CODE_MODAL_TITLE')}
        footer={null}
        open={modalVisible}
        onCancel={() => onModalConfirm(false)}
      >
        <ModalContentConfirm
          title={
            <div>
              {t('Modal', 'PRODUCT_CODE_DELETE_CONFIRM')}
              <StyledListBoldWrapper>{productCode.Name}</StyledListBoldWrapper>
            </div>
          }
          onConfirm={onModalConfirm}
        />
      </Modal>
      <Layout />
      <StyledListWrapper>
        <StyledListTitleWrapper>
          <StyledMainTitle> {t('ProductCodesPage', 'PRODUCT_CODES_REPOSITORY_PAGE_H2')} </StyledMainTitle>
          <StyledListButtonWrapper>
            {canWriteProductCodes && (
              <ButtonPrimary onClick={onClickCreateHandler}> {t('Buttons', 'ADD_PRODUCT_CODE')} </ButtonPrimary>
            )}
          </StyledListButtonWrapper>
        </StyledListTitleWrapper>
        {status === 'loading' && <Skeleton />}
        {status === 'success' && <ProductCodeTable canWrite={canWriteProductCodes} onClickDelete={onDeleteHandler} />}
      </StyledListWrapper>
    </div>
  );
};

export default ProductCodes;
